import React, { Component } from 'react'
import Dial from '../dial'
import { emit } from '../../../services/sockets'

const waveforms = ['sine', 'square', 'triangle', 'sawtooth']

const styles = {
  dials: {
    margin: '0 auto',
    justifyContent: 'space-around',
    width: '25%',
  },
}
export default class WebAudio extends Component {
  state = { waveform: waveforms[0] }
  _handleDetuneChange = detune => {
    emit('detune', detune)
  }

  _handleWaveTypeChange = index => {
    emit('wavetype', waveforms[index])
    this.setState({ waveform: waveforms[index] })
  }

  render() {
    return (
      <div>
        <div className="flex-row" style={styles.dials}>
          <Dial
            title="detune"
            sensitivity={0.1}
            min={-4800}
            max={3900}
            initialValue={0}
            step={10}
            onChange={this._handleDetuneChange}
          />
          <Dial
            title={this.state.waveform}
            sensitivity={1}
            min={0}
            max={3}
            initialValue={0}
            step={1}
            onChange={this._handleWaveTypeChange}
            snap // IMPLEMENT THIS
          />
        </div>
      </div>
    )
  }
}
